const WithdrawalStatus = {
  REQUESTED: 'REQUESTED',
  ANALYZE: 'ANALYZE',
  ACCEPTED: 'ACCEPTED',
  DENIED: 'DENIED',
  REFUNDED: 'REFUNDED',
  PROGRESS: 'PROGRESS',
  PROCESSING: 'PROCESSING',
  BEING_WORKED_ON: 'BEING_WORKED_ON',
  APPROVED: 'APPROVED',

  getHasAnalyzed() {
    return [
      this.ACCEPTED,
      this.DENIED
    ];
  },

  getHasXGrowWithdrawal() {
    return [
      this.ACCEPTED,
      this.DENIED,
      this.ANALYZE,
      this.REQUESTED,
      this.PROCESSING,
      this.BEING_WORKED_ON,
      this.APPROVED
    ]
  },

  getLabel(status) {
    switch (status) {
      case this.REQUESTED:
        return 'Não analisado';
      case this.ANALYZE:
        return 'Em espera';
      case this.ACCEPTED:
        return 'Saque transferido';
      case this.DENIED:
        return 'Saque recusado';
      case this.PROCESSING:
        return 'Processando dados';
      case this.BEING_WORKED_ON:
        return 'Em andamento';
      case this.APPROVED:
        return 'Saque analisado';
      case this.REFUNDED:
        return 'Reembolsado';
      default:
        return status;
    }
  },

  getHistoryLabel(status) {
    switch (status) {
      case this.REQUESTED:
        return 'Solicitado';
      case this.ANALYZE:
        return 'Em espera';
      case this.ACCEPTED:
        return 'Aceito';
      case this.DENIED:
        return 'Recusado';
      case this.PROCESSING:
        return 'Processando dados';
      case this.BEING_WORKED_ON:
        return 'Em andamento';
      case this.APPROVED:
        return 'Saque analisado';
      case this.REFUNDED:
        return 'Reembolsado';
      default:
        return status;
    }
  },

  getStyle(status) {
    switch (status) {
      case this.APPROVED:
      case this.ACCEPTED:
        return {
          background: 'var(--Primary-50, #EBFEF6)',
          color: 'var(--Primary-700, #007C5D)',
        };
      case this.DENIED:
        return {
          background: 'var(--Red-50, #FFF3ED)',
          color: 'var(--Red-700, #C71307)',
        };
      case this.REQUESTED:
      case this.ANALYZE:
        return {
          background: 'var(--Yellow-50, #FEFCE8)',
          color: 'var(--Yellow-700, #9E610A)',
        };
      case this.BEING_WORKED_ON:
      case this.PROCESSING:
        return {
          background: 'var(--Blue-50, #EFF6FF)',
          color: 'var(--Blue-700, #1A52DB)',
        };
    }
  }
};

export default WithdrawalStatus;
